/* eslint-disable import/no-anonymous-default-export */
import { ENDPOINT, HTTP } from "../../config";
import { fetchFromLawfeed } from "../../fetchFromLawfeed";


export default async (userId, folderId, caseId) => {
    console.log(userId, folderId, caseId, !!caseId);
    
    const params = [folderId ?? 'null', ...(caseId ? [caseId] : [])];
    return await fetchFromLawfeed({ method: HTTP.GET, endpoint: ENDPOINT.TREE, routeParams: [userId, ...params] });
}